module.exports = __webpack_public_path__ + "img/18-1.234c4b94.png";